import React from 'react';

import { Route, BrowserRouter, Routes as Switch } from 'react-router-dom';

import PlatformRoutes from './platform';

import ResetPassword from 'pages/Login/ResetPassword';
import Invited from 'pages/Invited';
import ForgotPassword from 'pages/Login/ForgotPassword';
import SignUpProtocol from 'pages/Login/SignUpProtocol';
import TicketRating from 'pages/Tickets/Rating';
import { Totem } from 'pages/Totem';
import { RegulatoryDocument } from 'pages/RegulatoryDocument'
import { DeliveryScheduling } from 'pages/DeliveryScheduling';
import PageOut from 'pages/PageOut';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/totem" element={<Totem />} />
        <Route path="/regulatory-document/:id" element={<RegulatoryDocument />} />
        <Route path="/agendamento-entrega" element={<DeliveryScheduling />} />
        <Route path="/convidado" element={<Invited />} />
        <Route path="/ticket-rating" element={<TicketRating />} />
        <Route path="/esqueci-minha-senha" element={<ForgotPassword />} />
        <Route path="/manutencao" element={<PageOut />} />
        <Route path="/cadastro-via-protocolo" element={<SignUpProtocol />} />
        <Route path="/nova-senha" element={<ResetPassword />} />
        <Route path="*" element={<PlatformRoutes />} />
      </Switch>
    </BrowserRouter>
  );
}
